module.exports = __webpack_public_path__ + "static/img/9.602bfcc5.png";